const translations = {
    applicator: 'Applicator',
    customer: 'Customer',
    job: 'Job',
    noJobs: 'No Jobs Scheduled',
    numSites: 'No. Sites',
    status: 'Status',
    time: 'Time',
    workOrderNumberKey: 'Work Order #'
};

export default translations;
